import {axios, API, SendRequest, toastr, WebsiteCookies} from '@/imports-files/pages/clients/jobs/new';

export class CandidateProfileJobService extends SendRequest 
{
  async like_dislike( params, job_applicant_id) 
  {
    try {
      const result = await axios.post( API.client.applicant.LIKE_CANDIDATE.replace('$job_applicant_id', job_applicant_id),
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }


  async getApplicationsData( params) 
  {
    const url = API.client.applicant.CANDIDATE_INFO.replace('$application_id', params.applicant_id);
    try {
      const result = await axios.get( url,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async getApplicationsDataWhenRestricted( params) 
  {
    const url = API.client.applicant.VIEW_APPLICATION_PROFILE;
    try {
      const result = await axios.get( url,
        {
          params: params,
          headers: this.customHeaderJSON() 
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async getCandidateGeneralViewData( params) 
  {
    const url = API.client.applicant.GENERAL_PROFILE.replace('$candidate_id', params.candidate_id);
    try {
      const result = await axios.get( url,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }
  

  async addNote(params, applicant_id)
  {
    try {
            const result = await axios.post( API.client.applicant.ADD_NOTE.replace('$applicant_id', applicant_id),
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
    catch (error) {
                    return error;
                  }
  }
  async editNote(params, applicant_id, note_id)
  {
    try {
            const result = await axios.patch( API.client.candidates.UPDATE_NOTE.replace(
              "$applicant_id",
              applicant_id
            ).replace("$note_id", note_id),
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
    catch (error) {
                    return error;
                  }
  }

  async restrictedLikeDislike( params) 
  {
    try {
        const result = await axios.post( API.client.applicant.RESTRICTED_LIKE_CANDIDATE,
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
        return result;
    } 
    catch (error) {
      return error;
    }
  }
  
  async restrictedAddNote(params)
  {
    try {
            const result = await axios.post( API.client.applicant.RESTRICTED_ADD_NOTES,
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
    catch (error) 
    {
                    return error;
    }
  }
  async restrictedEditNote(params, note_id)
  {
    try {
            const result = await axios.patch( API.client.applicant.RESTRICTED_EDIT_NOTES.replace('$note_id', note_id),
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
    catch (error) 
    {
                    return error;
    }
  }

  async cancelDocumentAction(contract_id) {
    try {
      const result = await axios.put(
        API.client.contracts.CANCEL.replace("$id", contract_id),
        {
          headers: this.customHeaderJSON(),
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON()
      );
      return result;
    } catch (error) {
      return error;
    }
  }

  
  async shareWithNameSuggestion(params) 
  {
    try {
      const result = await axios.get( API.client.jobs.GET_CLIENT_USERS,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async resendInvite(meetingId, interview_type){
    const params = {interview_type: interview_type}
    try {
      const result = await axios.post( API.client.cronofy.RESEND_INVITE.replace('$meeting_id', meetingId),
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async getDetails(params, action){
    let url = action == 'new' ? API.client.cronofy.GET_NEW_MEETING_DETAILS : API.client.cronofy.GET_MEETING_DETAILS.replace('$meeting_id', params.job_application_meeting_id)
    try {
      const result = await axios.get( url,
        {
          headers: this.customHeaderJSON(),
          params: params
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async addInterview(params){
    axios.defaults.timeout = 5 * 60 * 1000;
    try {
      const result = await axios.post( API.client.cronofy.ADD_INTERVIEW,
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async setupInterview(params){
    axios.defaults.timeout = 5 * 60 * 1000;
    try {
      const result = await axios.post( API.client.cronofy.SETUP_INTERVIEW,
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    }
    catch (error) {
      return error;
    }
  }

  async viewDetails(meetingId){
    try {
      const result = await axios.get( API.client.cronofy.VIEW_MEETING_DETAILS.replace('$meeting_id', meetingId),
        {
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  
  async viewRequest(meetingId){
    try {
      const result = await axios.get( API.client.cronofy.VIEW_MEETING_REQUEST.replace('$meeting_id', meetingId),
        {
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async cancelInterview(params, meetingId) 
  {
    try {
      const result = await axios.post( API.client.cronofy.CANCEL_INTERVIEW_BY_CLIENT.replace('$meeting_id', meetingId),
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async rescheduleInerview(params, meetingId) 
  {
    try {
      const result = await axios.post( API.client.cronofy.RESCHEDULE_INTERVIEW.replace('$meeting_id', meetingId),
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async getNoOfSlots(params, meetingId) 
  {
    try {
      const result = await axios.get( API.client.cronofy.AVAILABLE_SLOTS.replace('$meeting_id', meetingId),
          {
            params: params,
            headers: this.customHeaderJSON()
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async acceptSlotRequest(params, meetingId) 
  {
    try {
      const result = await axios.post( API.client.cronofy.ACCEPT_SLOT.replace('$meeting_id', meetingId),
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async getUserByNameOrEmail(params) {
    try {
      const result = await axios.get( API.client.jobs.GET_USERS_LIST,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async downloadContract(contractId)
  {
    try
    {
      const result = await axios.post(API.client.contracts.DOWNLOAD.replace('$contract_id', contractId),
      {},
      this.setCustomHeaderFileDownloadJSON(),
      this.setCrossDomainTrue(),
      this.setCredentialsJSON());
      return result;
    }
    catch (error)
    {
      return error;
    }
  }

  async previewContract(contractId){
    try {
      const result = await axios.get(API.client.contracts.PREVIEW.replace('$contract_id', contractId),
        {
          params: {},
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    }
    catch (error) {
      return error;
    }
  }
}
